export class PaginatorLoadData {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
